// logoReducer.js
import {
    FETCH_LOGO_REQUEST,
    FETCH_LOGO_SUCCESS,
    FETCH_LOGO_FAILURE,
  } from '../actions/logoTypes';
  
  const initialState = {
    loading: false,
    logoUrl: null,
    error: null,
  };
  
  export const logoReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_LOGO_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case FETCH_LOGO_SUCCESS:
        return {
          ...state,
          loading: false,
          logoUrl: action.payload,
        };
      case FETCH_LOGO_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  

  